<script>
export default {
  components: {}
}
</script>

<template>
  <div>
    <div class="account-pages mt-5 mb-5">
      <div class="container">
        <slot />
      </div>
    </div>
    <footer class="footer footer-alt">
      2020 &copy; Vikingo
    </footer>
  </div>
</template>
